<template>
  <base-form :title="$t('generic.details')"
             :loading="loading"
             @submit="submit">
    <div class="d-flex">
      <div class="pr-4">
        <fg-input :label="$t('generic.image')">
          <image-upload id="job-board-image"
                        @on-change="onImageChange"
                        :name="model.name"
                        :src="model.logo">
          </image-upload>
        </fg-input>

        <fg-input :label="$t('generic.favicon')">
          <image-upload id="job-board-favicon"
                        @on-change="onFavIconChange"
                        size="md"
                        :name="model.name"
                        :src="model.favicon">
          </image-upload>
        </fg-input>

      </div>
      <div class="col-12 col-sm-8 col-xl-10">
        <fg-input :placeholder="$t('jobBoard.details.edit.name')"
                  :name="$t('jobBoard.details.edit.name')"
                  required
                  :error="getError($t('jobBoard.details.edit.name'))"
                  :label="$t('jobBoard.details.edit.name')"
                  v-validate="modelValidations.name"
                  v-model="model.name">
        </fg-input>
        <fg-input :error="getError($t('jobBoard.details.edit.description'))"
                  required
                  :label="$t('jobBoard.details.edit.description')">
          <textarea placeholder="Here can be your nice text"
                    rows="3"
                    class="form-control"
                    :placeholder="$t('jobBoard.details.edit.description')"
                    :name="$t('jobBoard.details.edit.description')"
                    v-validate="modelValidations.description"
                    v-model="model.description">
          </textarea>
        </fg-input>

        <fg-input :placeholder="$t('jobBoard.details.edit.email')"
                  :name="$t('jobBoard.details.edit.email')"
                  :error="getError($t('jobBoard.details.edit.email'))"
                  :label="$t('jobBoard.details.edit.email')"
                  v-validate="modelValidations.email"
                  v-model="model.email_send_address">
        </fg-input>

        <fg-input :placeholder="$t('jobBoard.details.edit.emailName')"
                  :name="$t('jobBoard.details.edit.emailName')"
                  :error="getError($t('jobBoard.details.edit.emailName'))"
                  :label="$t('jobBoard.details.edit.emailName')"
                  v-validate="modelValidations.emailName"
                  v-model="model.email_send_name">
        </fg-input>

      </div>
    </div>
  </base-form>
</template>
<script>
  import { mapState } from 'vuex'
  import ImageUpload from 'src/components/ImageUpload'
  import JobBoardService from 'src/services/JobBoardService'

  export default {
    name: 'job-board-settings',
    components: {
      ImageUpload
    },
    data () {
      return {
        model: {},
        loading: false,
        modelValidations: {
          name: {
            required: true
          },
          description: {
            required: true,
            max: 400
          },
          email: {
            email: true
          },
          url: {
            url: true
          },
          rank: {
            numeric: true,
            min_value: 0
          }
        }
      }
    },
    computed: {
      ...mapState('jobs', {
        jobBoard: state => state.currentJobBoard
      })
    },
    methods: {
      getError (name) {
        return this.errors.first(name)
      },
      onImageChange (file) {
        this.model.logo = file
      },
      onFavIconChange (file) {
        this.model.favicon = file
      },
      deleteNullValues (obj) {
        for (let key in obj) {
          if (obj[key] === null) {
            delete obj[key]
          }
        }
        return obj
      },
      async submit () {
        let valid = await this.$validator.validateAll()
        if (!valid) return
        let updatedValues = {
          ...this.model
        }
        updatedValues = this.deleteNullValues(updatedValues)
        try {
          this.loading = true
          await JobBoardService.update(this.$route.params.id, updatedValues)
        } finally {
          this.loading = false
        }
      }
    },
    created () {
      this.$watch('jobBoard', newVal => {
        this.model = {
          ...newVal
        }
      }, {immediate: true})
    }
  }
</script>
<style>
</style>
